import Type from "./Type";
import FormatCode from "./FormatCode";

export default class Convert {
    // テーブル
    static key_split(key,unit="__") {
        let data
        if (key.includes("|")){
            data = key.substring(key.lastIndexOf("|"), key.length).split(unit);
        } else {
            data = key.split(unit);
        }
        return {table:data[0],column:data[1]};
    }
    static get_view_value(name, data){
        name = name.split('|')
        const columnString = name[name.length-1]
        const columnObject = this.key_split(columnString, '__')
        name[name.length-1] = columnObject.column
        const getValueFromData = () =>{
            var tmp_data = ""
            var tmp_name = ""
            if (name.length>1){
                return tmp_data = name.reduce((acc, value)=>{
                    return (acc && (Object.keys(acc).length > 0)&& acc[value])?acc[value]:undefined
                }, data)
            } else {
                return tmp_data = data[name[0]]
            }
        }

        const type = Type.validate(columnString);
        if (type !== undefined && type.disp){
            return Object.keys(type.disp).reduce((acc, typeName)=>{
                if (!type.disp[typeName]) {
                    return acc
                }else if(typeName==="format"){
                    return FormatCode.decode(type.disp.format, acc)
                }else if(typeName==="unit"){
                    return acc!=null?(acc+""+type.disp.unit):""
                }
            }, getValueFromData())
        } else {
            return getValueFromData()
        }
    }
}